import { FC } from 'react';
import { CommonPageTDK, DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $SEOCurrentTraffic } from 'shared/atoms';

const SugCanonical: FC = () => {
  const { canonicalUrl } = useAtomValue($SEOCurrentTraffic);

  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
    </DynamicHead>
  );
};

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <SugCanonical />;
}

export const SugTDK: FC = () => {
  const tdkInfo = {
    title: 'Lemon8',
    description: 'Lemon8 Search Page',
    keywords: ['Lemon8 sug', 'Lemon8 Search'],
  };

  return <PageTDK {...tdkInfo} />;
};
